import {GUEST_LIST_ITEM_ARRIVAL_STATE, GUEST_LIST_ITEM_REQUEST_STATE} from '../guest-list-item';

export class CreateUpdateGuestListItemCommand {
  constructor(venueDetailsId, guestProfileId, fullName, email, phoneNumber, date, guestCount, note) {
    this.venueDetailsId = venueDetailsId;
    this.guestProfileId = guestProfileId;
    this.note = note;
    this.fullName = fullName;
    this.email = email;
    this.phoneNumber = phoneNumber;
    this.date = date;
    this.guestCount = guestCount;
    this.requestState = GUEST_LIST_ITEM_REQUEST_STATE.Approved;
    this.arrivalState = GUEST_LIST_ITEM_ARRIVAL_STATE.NotArrived
  }
}
